/**
 * Ach webpack: Ist das wirklich die beste Idee, um ein CSS zu produzieren?
 */

import './brix-styles.scss';
